import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=90a037bc&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShoppingListProductCard: require('/vercel/path0/components/profile/shopping-list/ShoppingListProductCard.vue').default,AddShoppingListToCart: require('/vercel/path0/components/shop/AddShoppingListToCart.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
